module.exports = __webpack_public_path__ + "img/a1-s6.99bbf655.jpg";